module.exports = __webpack_public_path__ + "static/media/NoCertiAvailable.ea7ac141.svg";